












import queries from "@/gql/queries.coffee"
  
export default {
  name: "EstablishmentReviewContent"
  data: ()->
    return {
      text_fr: "",
      text_native: "",
      text_signaling: ""      
    }
  props: {
    review:{
      type: Object
    },
  }
  mounted: ()->
    resp = await queries.run("get_review_content", [this.review.uid])
    @text_fr = resp.data.data.review_content.text_fr
    @text_native = resp.data.data.review_content.text_native
    @text_signaling = resp.data.data.review_content.text_signaling
    console.log("text_signaling", @text_signaling)
}

